import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-text-[20px] tw-font-semibold tw-leading-[130%] tw-mr-[7px]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-items-center tw-justify-center tw-w-[26px] tw-h-[26px] tw-min-w-[26px] tw-min-h-[26px] tw-bg-[#FFFFFF] tw-rounded-[50%]" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[#387DFF] tw-text-base tw-font-medium tw-mt-[2px]" }, "+")
], -1)

import { getComponentUiText } from "@/utils/utilities";


export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentCreateButton',
  props: {
  title: {
    type: String,
    default: getComponentUiText("app-assessment-button-create-button-1"),
    required: false,
  },
  btnStyle: {
    type: String,
    default: "tw-px-[25px] tw-py-[16px]",
    required: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    id: "ma-btn-create-assessment",
    "data-cy": "ma-btn-create-assessment",
    class: _normalizeClass(`tw-flex tw-items-center tw-justify-between tw-w-full tw-leading-[130%] tw-bg-[#387DFF] tw-text-white tw-rounded-md ${__props.btnStyle}`)
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(__props.title), 1),
    _hoisted_2
  ], 2))
}
}

})